export default {
	methods: {
		getReadablePhaseName (phase) {
			switch (phase) {
			case 'pre': return 'Vorbereitung'
			case 'warmup': return 'Aufwärmphase'
			case 'first-half': return 'Erste Halbzeit'
			case 'half-time-break': return 'Halbzeitpause'
			case 'second-half': return 'Zweite Halbzeit'
			case 'pre-extra-time': return 'Pause vor Verlängerung'
			case 'first-extra-time': return 'Erste Halbzeit der Verlängerung'
			case 'extra-time-break': return 'Halbzeitpause der Verlängerung'
			case 'second-extra-time': return 'Zweite Halbzeit der Verlängerung'
			case 'pre-shootout': return 'Vor dem Elfmeterschießen'
			case 'penalty-shootout': return 'Elfmeterschießen'
			case 'post': return 'Zusammenfassung'
			default: return 'UNKNOWN PHASE: ' + phase
			}
		},
		getTransitionAction (fromPhase, toPhase) {
			if (fromPhase === 'pre' && toPhase === 'warmup') {
				return 'warmup-start'
			} else if (fromPhase === 'warmup' && toPhase === 'first-half') {
				return 'first-half-start'
			} else if (fromPhase === 'first-half' && toPhase === 'half-time-break') {
				return 'first-half-end'
			} else if (fromPhase === 'half-time-break' && toPhase === 'second-half') {
				return 'second-half-start'
			} else if (fromPhase === 'second-half' && (toPhase === 'post' || toPhase === 'pre-extra-time' )) {
				return 'second-half-end'
			} else if (fromPhase === 'pre-extra-time' && toPhase === 'first-extra-time') {
				return 'first-extra-time-start'
			} else if (fromPhase === 'first-extra-time' && toPhase === 'extra-time-break') {
				return 'first-extra-time-end'
			} else if (fromPhase === 'extra-time-break' && toPhase === 'second-extra-time') {
				return 'second-extra-time-start'
			} else if (fromPhase === 'second-extra-time' && (toPhase === 'post' || toPhase === 'pre-shootout')) {
				return 'second-extra-time-end'
			} else if (fromPhase === 'pre-shootout' && toPhase === 'penalty-shootout') {
				return 'penalty-shootout-start'
			} else if (fromPhase === 'penalty-shootout' && toPhase === 'post') {
				return 'penalty-shootout-end'
			}
			return `Unknown transition: ${fromPhase} -> ${toPhase}`
		},
		getTransitionActionReadableName (transition) {
			switch (transition) {
			case 'warmup-start': return 'Start des Livetickers'
			case 'first-half-start': return 'Anpfiff 1. Halbzeit'
			case 'first-half-end': return 'Abpfiff 1. Halbzeit'
			case 'second-half-start': return 'Anpfiff 2. Halbzeit'
			case 'second-half-end': return 'Abpfiff 2. Halbzeit'
			case 'first-extra-time-start': return 'Anpfiff 1. Halbzeit der Verlängerung'
			case 'first-extra-time-end': return 'Abpfiff 1. Halbzeit der Verlängerung'
			case 'second-extra-time-start': return 'Anpfiff 2. Halbzeit der Verlängerung'
			case 'second-extra-time-end': return 'Abpfiff 2. Halbzeit der Verlängerung'
			case 'penalty-shootout-start': return 'Beginn des Elfmeterschießens'
			case 'penalty-shootout-end': return 'Ende des Elfmeterschießens'
			}
		},
		getNextPhase (currentPhase, ruleSet, homeScore, awayScore) {
			switch (currentPhase) {
			case 'pre': return 'warmup'
			case 'warmup': return 'first-half'
			case 'first-half': return 'half-time-break'
			case 'half-time-break': return 'second-half'
			case 'second-half':
				if (ruleSet === 'league' || homeScore !== awayScore) {
					return 'post'
				} else {
					return 'pre-extra-time'
				}
			case 'pre-extra-time': return 'first-extra-time'
			case 'first-extra-time': return 'extra-time-break'
			case 'extra-time-break': return 'second-extra-time'
			case 'second-extra-time':
				if (homeScore !== awayScore) {
					return 'post'
				} else {
					return 'pre-shootout'
				}
			case 'pre-shootout': return 'penalty-shootout'
			case 'penalty-shootout': return 'post'
			default: return null
			}
		},
		isPhaseTimed (phase) {
			switch (phase) {
			case 'first-half':
			case 'second-half':
			case 'first-extra-time':
			case 'second-extra-time':
				return true
			default:
				return false
			}
		},
		getPhasesForRuleset (ruleset) {
			switch (ruleset) {
			case 'league':
				return [
					'pre',
					'warmup',
					'first-half',
					'half-time-break',
					'second-half',
					'post'
				]
			case 'cup':
				return [
					'pre',
					'warmup',
					'first-half',
					'half-time-break',
					'second-half',
					'pre-extra-time',
					'first-extra-time',
					'extra-time-break',
					'second-extra-time',
					'pre-shootout',
					'penalty-shootout',
					'post'
				]
			default:
				return []
			}
		},
		getInitialMinutesForPhase (phase) {
			switch (phase) {
			case 'first-half': return 0
			case 'second-half': return 45
			case 'first-extra-time': return 90
			case 'second-extra-time': return 105
			default: return 0
			}
		},
		getRegularDurationForPhase (phase) {
			switch (phase) {
			case 'first-half':
			case 'second-half':
				return 45
			case 'first-extra-time':
			case 'second-extra-time':
				return 90
			default: return 0
			}
		}
	}
}
